export default {
  SET_LOCATION_IMG(state, data) {
    state.locationImg = data;
  },
};
